import { render, staticRenderFns } from "./appSettings.vue?vue&type=template&id=14af0204"
import script from "./appSettings.vue?vue&type=script&lang=js"
export * from "./appSettings.vue?vue&type=script&lang=js"
import style0 from "./appSettings.vue?vue&type=style&index=0&id=14af0204&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports